var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defer, EMPTY, merge, of, Subject } from 'rxjs';
import { catchError, map, retryWhen, shareReplay, startWith, } from 'rxjs/operators';
import { ajax, AjaxError } from 'rxjs/ajax';
import { attachmentsUrl, gcsConfigUrl } from './consts';
import { validateAttachment, formatBytes } from '../utils/helpers/helpers';
import { addCsrfTokenHeader, getCsrfToken } from '../api/csrf';
import { getErrors } from '../api/exceptions';
import { getJson } from '../api/ajax';
export var uploadAttachment = function (file, fileLimits) {
    var errors = validateAttachment(file, fileLimits);
    if (Object.keys(errors).length) {
        return of({
            success: false,
            errors: errors,
        });
    }
    var formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('type', 'CV');
    formData.append('primary', 'true');
    var progressSubscriber = new Subject();
    var upload$ = ajax({
        url: attachmentsUrl,
        method: 'POST',
        headers: __assign(__assign({}, addCsrfTokenHeader(getCsrfToken())), { 'source-system': 'pro.registration-confirmation-success-modal' }),
        progressSubscriber: progressSubscriber,
        body: formData,
    }).pipe(map(function (res) {
        if (res.status <= 400)
            return res;
        throw res;
    }), retryWhen(function (err) {
        return err.pipe(map(function (res, i) {
            if (res.status === 403 && i < 1)
                return defer(function () { return res; });
            throw res;
        }));
    }), map(function () { return ({ success: true, errors: {} }); }), catchError(function (err) {
        if (err instanceof AjaxError &&
            err.status === 400 &&
            'ValidationErrors' in err.response) {
            return of({
                success: false,
                errors: getErrors(err.response.ValidationErrors),
            });
        }
        else {
            return of({ success: false, errors: {} });
        }
    }));
    return merge(progressSubscriber.pipe(catchError(function () { return EMPTY; })), upload$);
};
var defaultGCSConfig = {
    themeId: 'core',
    headerBackgroundColor: 'core',
    siteBackgroundColor: 'colorWhite',
    uploadFileType: ['pdf', 'doc', 'docx', 'rtf'],
    supportedMimeTypes: [
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/pdf',
        'application/rtf',
        'text/rtf',
    ],
    uploadFileSizeMb: '1mb',
    uploadFileSize: 1048576,
    uploadFileSizeMinimum: 8192,
    favicon: '/sharedassets/favicon/core/favicon.png',
    legacySiteId: 250,
    site: 'StepStoneDE',
    locales: ['en-DE', 'de-DE'],
    defaultLocale: 'de-DE',
    languages: ['en', 'de'],
    defaultLanguage: 'de',
    atsiJobBoardId: 'stepstone_de',
};
var configToFileLimits = function (config) { return ({
    uploadFileSize: config.uploadFileSize,
    uploadFileSizeMb: config.uploadFileSizeMb,
    uploadFileSizeMinimum: config.uploadFileSizeMinimum,
    uploadFileType: config.uploadFileType,
    supportedMimeTypes: config.supportedMimeTypes,
}); };
export var generateFileLimitsPlaceholders = function (value) {
    return {
        uploadFileType: Array.isArray(value.uploadFileType)
            ? value.uploadFileType.map(function (ext) { return ".".concat(ext); }).join(', ')
            : value.uploadFileType,
        uploadFileSizeMb: value.uploadFileSizeMb,
        uploadFileSize: formatBytes(value.uploadFileSize),
        uploadFileSizeMinimum: formatBytes(value.uploadFileSizeMinimum),
    };
};
export var defaultFileLimits = configToFileLimits(defaultGCSConfig);
export var gcsConfig$ = getJson(gcsConfigUrl).pipe(map(configToFileLimits), startWith(defaultFileLimits), catchError(function () { return of(defaultFileLimits); }), shareReplay(1));
//# sourceMappingURL=api.js.map